const fwuErrors = [
  { id: "general", code: 72 },
  { id: "timeout", code: 25 },
  { id: "cm", code: 30 },
  { id: "battery", code: 35 }
];

export default fwuErrors;
